import React from "react";
import { Card, Row, Col, Typography, Space } from "antd";
import {
  HomeOutlined,
  EnvironmentOutlined,
  DollarOutlined,
  RiseOutlined,
} from "@ant-design/icons";
import CustomCard from "../../blocks/Card/Card";

const { Title, Text } = Typography;

const PropertyFeaturesHighlight = () => {
  const features = [
    {
      icon: <HomeOutlined style={{ fontSize: 24, color: "#97c23c" }} />,
      title: "Living Space",
      value: "3,872 Sq Ft",
    },
    {
      icon: <EnvironmentOutlined style={{ fontSize: 24, color: "#97c23c" }} />,
      title: "Lot Size",
      value: "16,864 Sq Ft",
    },
    {
      icon: <DollarOutlined style={{ fontSize: 24, color: "#97c23c" }} />,
      title: "Estimated Value",
      value: "$4,000,000",
    },
    {
      icon: <RiseOutlined style={{ fontSize: 24, color: "#97c23c" }} />,
      title: "1 Year Appreciation",
      value: "3.31%",
    },
  ];

  return (
    <CustomCard
      title={<Title level={4}>Property Highlights</Title>}
      className="card-height"
    >
      <Row gutter={[16, 16]}>
        {features.map((feature, index) => (
          <Col xs={24} sm={12} key={index}>
            <Card style={{ backgroundColor: "#f5f5f5" }}>
              <Space align="start">
                <div>{feature.icon}</div>
                <div>
                  <Text type="secondary">{feature.title}</Text>
                  <br />
                  <Text strong style={{ fontSize: 18 }}>
                    {feature.value}
                  </Text>
                </div>
              </Space>
            </Card>
          </Col>
        ))}
      </Row>
    </CustomCard>
  );
};

export default PropertyFeaturesHighlight;
